import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GenerateSmartLockChallengeResData } from "./GenerateSmartLockChallengeResData";

const ENDPOINT = "/otc/smartlock/open";

export class EnableSmartLockCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: EnableSmartLockReqData;

    constructor(installationName: string, serialNumber: string) {
        super();
        this.payload = new EnableSmartLockReqData(installationName, serialNumber);
    }

    public async execute(): Promise<GenerateSmartLockChallengeResData> {
        let res = await this.executeCommand(this.payload);
        return new GenerateSmartLockChallengeResData(res);
    }
}

export class EnableSmartLockReqData {
    installationName: string;
    serialNumber: string;

    constructor(installationName: string, serialNumber: string) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
    }
}
